import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import _ from 'lodash';

class ChargifyDirectParameters extends DomainObject {
  id;

  apiId;
  timestamp;
  nonce;
  data;
  signature;

  firstName;
  lastName;

  cardNumber;
  expirationMonthIndex;
  expirationYear;
  cvv;

  billingAddress;
  billingAddress2;
  billingCity;
  billingState;
  billingZip;
  billingCountry;

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      apiId: observable,
      timestamp: observable,
      nonce: observable,
      data: observable,
      signature: observable,
      firstName: observable,
      lastName: observable,
      cardNumber: observable,
      expirationMonthIndex: observable,
      expirationYear: observable,
      cvv: observable,
      billingAddress: observable,
      billingAddress2: observable,
      billingCity: observable,
      billingState: observable,
      billingZip: observable,
      billingCountry: observable,
      expirationMonth: computed
    });

    this.merge(other);
  }

  _afterMerge() {
    if (this.billingCountry && _.isString(this.billingCountry)) {
      this.billingCountry = {id: this.billingCountry};
    }

    if (this.billingState && _.isString(this.billingState)) {
      this.billingState = {id: this.billingState};
    }
  }

  get expirationMonth() {
    const i = parseInt(this.expirationMonthIndex);
    if (i === 0 || i) {
      return i + 1;
    }
    return '';
  }

  set expirationMonth(value) {
    const i = parseInt(value);

    if (i) {
      this.expirationMonthIndex = i - 1;
    } else {
      this.expirationMonthIndex = '';
    }
  }
}

export default ChargifyDirectParameters;
